module.exports = __webpack_public_path__ + "static/media/firebase.45b099fd.svg";